<template>
  <div class="home-page">

    <!-- ── Filtros ── -->
    <div class="home-toolbar">
      <v-btn outlined rounded elevation="0" color="#64748b" small @click="dlg_filtros = true" class="px-4">
        <v-icon left small>mdi-filter-outline</v-icon>
        <span style="font-size:12px">Filtrar período</span>
      </v-btn>
    </div>

    <!-- ── KPI Cards ── -->
    <div class="kpi-grid">
      <div class="kpi-card">
        <div class="kpi-card__icon-wrap" style="background:#fff3e0">
          <v-icon color="#ff7a00" size="20">mdi-file-document-multiple-outline</v-icon>
        </div>
        <div class="kpi-card__body">
          <div class="kpi-card__value">{{ dados.qt_dividas || 0 }}</div>
          <div class="kpi-card__label">Dívidas enviadas</div>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-card__icon-wrap" style="background:#e8f0fe">
          <v-icon color="#0052A0" size="20">mdi-currency-brl</v-icon>
        </div>
        <div class="kpi-card__body">
          <div class="kpi-card__value">{{ converterDinherio(dados.valor_vencido) }}</div>
          <div class="kpi-card__label">Valor registrado</div>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-card__icon-wrap" style="background:#fef2f2">
          <v-icon color="#ef4444" size="20">mdi-alert-circle-outline</v-icon>
        </div>
        <div class="kpi-card__body">
          <div class="kpi-card__value">{{ dados.qt_negativacoes || 0 }}</div>
          <div class="kpi-card__label">Dívidas negativadas</div>
        </div>
      </div>

      <div class="kpi-card">
        <div class="kpi-card__icon-wrap" style="background:#f0fdf4">
          <v-icon color="#22c55e" size="20">mdi-bell-outline</v-icon>
        </div>
        <div class="kpi-card__body">
          <div class="kpi-card__value">{{ dados.dividas_notificadas || 0 }}</div>
          <div class="kpi-card__label">Notificações</div>
        </div>
      </div>
    </div>

    <!-- ── Gráficos ── -->
    <div class="charts-grid">
      <div class="chart-card">
        <div class="chart-card__header">
          <div class="chart-card__icon-wrap">
            <v-icon color="#0052A0" size="18">mdi-chart-pie</v-icon>
          </div>
          <div>
            <div class="chart-card__title">Status das Dívidas</div>
            <div class="chart-card__sub">Distribuição por situação atual</div>
          </div>
        </div>
        <div class="chart-card__body">
          <apexchart
            v-if="series.length > 0"
            :key="chartKey"
            type="pie"
            width="100%"
            height="260"
            :options="chartOptions"
            :series="series"
          />
          <div v-else class="chart-empty">
            <v-icon size="48" color="#e2e8f0">mdi-chart-pie</v-icon>
            <p class="chart-empty__text">Sem dados para exibir</p>
          </div>
        </div>
      </div>

      <div class="chart-card">
        <div class="chart-card__header">
          <div class="chart-card__icon-wrap">
            <v-icon color="#0052A0" size="18">mdi-bell-badge-outline</v-icon>
          </div>
          <div>
            <div class="chart-card__title">Dívidas Notificadas</div>
            <div class="chart-card__sub">Percentual do total enviado</div>
          </div>
        </div>
        <div class="chart-card__body chart-card__body--center">
          <div class="progress-wrap">
            <v-progress-circular
              :size="140"
              :width="12"
              :value="dados.dividas_notificadas_percentual"
              color="#ff7a00"
              track-color="#f1f5f9"
            >
              <div class="progress-inner">
                <span class="progress-inner__value">{{ dados.dividas_notificadas_percentual }}%</span>
                <span class="progress-inner__label">notificadas</span>
              </div>
            </v-progress-circular>
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog filtros -->
    <v-dialog v-model="dlg_filtros" max-width="480" persistent>
      <v-card>
        <div class="dialog-header">
          <div class="dialog-header__icon-wrap">
            <v-icon color="#0052A0" size="18">mdi-filter-outline</v-icon>
          </div>
          <div>
            <div class="dialog-header__title">Definir Período</div>
            <div class="dialog-header__sub">Filtrar dados do dashboard</div>
          </div>
          <v-spacer />
          <v-btn icon small @click="dlg_filtros = false"><v-icon color="#64748b">mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pa-6">
          <v-row>
            <v-col cols="12" sm="6">
              <data-component
                v-model="srcBody.dataInicial"
                labelDate="Data Inicial"
                only-date
                outlined
                dense
                color="#0052A0"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <data-component
                v-model="srcBody.dataFinal"
                labelDate="Data Final"
                only-date
                outlined
                dense
                color="#0052A0"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions style="border-top:1px solid #f1f5f9;padding:14px 20px">
          <v-spacer />
          <v-btn text rounded color="grey darken-1" @click="dlg_filtros = false" class="mr-2">Cancelar</v-btn>
          <v-btn color="#ff7a00" rounded elevation="0" :loading="search_progress" @click="getDados()" class="px-6">
            <v-icon left color="#fff" small>mdi-magnify</v-icon>
            <span style="color:#fff;font-weight:700;font-size:13px">Buscar</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import DataComponent from "../../components/DataComponent";
import helper from "../../mixins/helper";

export default {
  components: { DataComponent },
  mixins: [helper],
  data: () => ({
    series: [],
    chartOptions: {
      chart: { width: "100%", type: "pie", background: "transparent" },
      labels: [],
      colors: ['#ff7a00', '#0052A0', '#22c55e', '#ef4444', '#8b5cf6', '#0086D4', '#f59e0b', '#64748b'],
      theme: { monochrome: { enabled: false } },
      plotOptions: { pie: { dataLabels: { offset: -5 } } },
      dataLabels: {
        enabled: true,
        // Fatias pequenas sem rótulo: sobrepunham no celular (o valor segue na legenda/tooltip)
        formatter(val) { return val < 8 ? "" : val.toFixed(1) + "%"; },
      },
      legend: {
        show: true,
        position: "bottom",
        labels: { colors: "#64748b", useSeriesColors: false },
      },
      responsive: [{ breakpoint: 600, options: { chart: { width: '100%' }, legend: { position: 'bottom' } } }],
    },
    chartKey: 0,
    dlg_filtros: false,
    search_progress: false,
    dados: {
      dividas_notificadas: 0,
      qt_dividas: 0,
      valor_registrado: 0,
      qt_negativacoes: 0,
      valor_vencido: 0,
      dividas_notificadas_percentual: 0,
      status_protocolos: [],
    },
    srcBody: { dataInicial: "2022-01-01", dataFinal: "" },
  }),

  mounted() {
    this.srcBody.dataFinal = new Date().toISOString().split('T')[0];
    if (this.$store.state.auth.user && this.$store.state.auth.user.menu && this.$store.state.auth.user.menu.length > 0) {
      this.items = this.$store.state.auth.user.menu;
    } else {
      if (this.$route.name !== "Cadastro de Credores") {
        this.$router.push({ name: "Cadastro de Credores" });
      }
    }
    this.getDados();
  },

  methods: {
    async getDados() {
      this.search_progress = true;
      await this.$http.post("relatoriosHome", this.srcBody).then(
        (response) => {
          this.dados = response.data;
          const total = Number(this.dados.qt_dividas) || 0;
          this.dados.dividas_notificadas_percentual = total
            ? Math.round((Number(this.dados.dividas_notificadas) / total) * 100)
            : 0;
          const labels = [];
          const seriesData = [];
          if (this.dados.status_protocolos && this.dados.status_protocolos.length > 0) {
            this.dados.status_protocolos.forEach((r) => {
              labels.push(r.nome);
              seriesData.push(parseInt(r.dividas));
            });
            this.$nextTick(() => {
              this.series = [...seriesData];
              this.chartOptions = { ...this.chartOptions, labels: [...labels] };
              this.chartKey++;
            });
          } else {
            this.series = [];
            this.chartOptions = { ...this.chartOptions, labels: [] };
          }
          this.dlg_filtros = false;
          this.search_progress = false;
        },
        () => { this.search_progress = false; }
      );
    },
  },
};
</script>

<style scoped>
/* ─── Layout ─────────────────────────────────────────── */
.home-page {
  background: #f8fafc;
  min-height: calc(100vh - 64px);
  padding: 28px 32px;
  box-sizing: border-box;
}
@media (max-width: 768px) { .home-page { padding: 16px; } }

/* ─── Toolbar ────────────────────────────────────────── */
.home-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
}

/* ─── KPI Grid ───────────────────────────────────────── */
.kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}
@media (max-width: 960px) { .kpi-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 600px) { .kpi-grid { grid-template-columns: 1fr; } }

.kpi-card {
  background: #fff;
  border: 1px solid #e9eef5;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  align-items: center;
  gap: 16px;
}
.kpi-card__icon-wrap {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.kpi-card__value {
  font-family: 'Inter', sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1.2;
}
.kpi-card__label {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #64748b;
  margin-top: 3px;
}

/* ─── Charts Grid ────────────────────────────────────── */
.charts-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
@media (max-width: 768px) { .charts-grid { grid-template-columns: 1fr; } }

.chart-card {
  background: #fff;
  border: 1px solid #e9eef5;
  border-radius: 12px;
  overflow: hidden;
}
.chart-card__header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid #f1f5f9;
}
.chart-card__icon-wrap {
  width: 34px;
  height: 34px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.chart-card__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 700;
  color: #1e293b;
}
.chart-card__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 1px;
}
.chart-card__body {
  padding: 20px;
  min-height: 260px;
  box-sizing: border-box;
}
.chart-card__body--center {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 260px;
}

/* ─── Empty chart ────────────────────────────────────── */
.chart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 48px 0;
}
.chart-empty__text {
  font-family: 'Inter', sans-serif;
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}

/* ─── Progress circular ──────────────────────────────── */
.progress-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
}
.progress-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
}
.progress-inner__value {
  font-family: 'Inter', sans-serif;
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e293b;
}
.progress-inner__label {
  font-family: 'Inter', sans-serif;
  font-size: 0.7rem;
  color: #94a3b8;
  margin-top: 2px;
}

/* ─── Dialog ─────────────────────────────────────────── */
.dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 24px;
  border-bottom: 1px solid #f1f5f9;
}
.dialog-header__icon-wrap {
  width: 34px; height: 34px;
  background: #e8f0fe;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.dialog-header__title {
  font-family: 'Inter', sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  color: #1e293b;
}
.dialog-header__sub {
  font-family: 'Inter', sans-serif;
  font-size: 0.78rem;
  color: #94a3b8;
  margin-top: 2px;
}
</style>
